import {
  FaRing, FaGlassCheers, FaBirthdayCake, FaBriefcase,
  FaMusic, FaHeart,
} from "react-icons/fa";

// ⭐ EDIT THIS — match lawn names/capacities with your old lawns.html page
export const lawnsData = [
  {
    id: 1,
    name: "Grand Wedding Lawn",
    image: "/images/Lawns/Lawn-1.png",
    capacity: "Up to 1,000 Guests",
    area: "20,000 sq.ft",
    short: "Our largest open venue — a sprawling green lawn designed for grand weddings, receptions and large-scale celebrations.",
    features: ["Mandap / Stage Setup", "DJ & Lighting Allowed", "Catering Space", "Valet Parking", "Bridal Room", "Generator Backup"],
  },
  {
    id: 2,
    name: "Party Lawn",
    image: "/images/Lawns/Lawn-5.jpg",
    capacity: "Up to 400 Guests",
    area: "10,000 sq.ft",
    short: "A vibrant open space perfect for birthday parties, anniversaries, sangeet nights and poolside celebrations.",
    features: ["Poolside Access", "DJ & Music", "Theme Décor Support", "Seating Arrangements", "Bonfire Setup (Winter)", "Ample Parking"],
  },
  {
    id: 3,
    name: "Garden Lawn",
    image: "/images/Lawns/Lawn-3.png",
    capacity: "Up to 250 Guests",
    area: "8,000 sq.ft",
    short: "A peaceful, landscaped garden surrounded by greenery — ideal for haldi, mehndi and intimate family functions.",
    features: ["Floral Walkways", "Photo Corners", "Shaded Sitting Areas", "Kids-Friendly Space", "Catering Support", "24×7 Security"],
  },
  {
    id: 4,
    name: "Corporate Event Lawn",
    image: "/images/Lawns/Lawn-4.png",
    capacity: "Up to 300 Guests",
    area: "9,000 sq.ft",
    short: "A professional open-air setup for corporate offsites, product launches, exhibitions and team events.",
    features: ["Stage & Podium", "Sound System", "Branding / Banner Space", "Wi-Fi Enabled", "Food Stalls Area", "Power Backup"],
  },
];

// Event types hosted on the lawns
export const eventTypes = [
  { icon: FaRing, title: "Weddings" },
  { icon: FaGlassCheers, title: "Receptions" },
  { icon: FaHeart, title: "Haldi & Mehndi" },
  { icon: FaBirthdayCake, title: "Birthday Parties" },
  { icon: FaMusic, title: "Sangeet Nights" },
  { icon: FaBriefcase, title: "Corporate Events" },
];